const hashStringParse = (input: string) => {
    let parsed = {};
    if (input != '') {
        input = input.replace("#/", "#");
        input = input.substring(input.indexOf('#') + 1);
        let p1 = input.split('&');
        p1.map(function (value) {
            let params = value.split('=')
            parsed[params[0]] = decodeURIComponent(params[1])
        });
    }
    return parsed;
}

function cleanUpEmptyProperties(state) {
    var processedState = {};
    state = state || {};

    for (var key in state) {
        if (state[key] && state[key].toString().length > 0) {
            processedState[key] = state[key];
        }
    }

    return processedState;
};

function buildHash(filters: any): string {

    filters = cleanUpEmptyProperties(filters);

    let index = 0;
    let resultHash = '#';

    for (var key in filters) {

        if (index > 0)
            resultHash += '&';

        if (filters[key] && filters[key].toString().length > 0) {
            resultHash += key + '=' + encodeURIComponent(filters[key]);
        }

        index++;
    }

    return resultHash;
}

export { hashStringParse, buildHash };
